/* eslint-disable no-use-before-define, no-restricted-globals, import/no-cycle, @typescript-eslint/no-use-before-define */
// @ts-expect-error
import Dropdowns from 'a11y-dropdown-component';
import addSelectDropdowns from '../dropdowns/select';
import addLazyLoad from '../lazyLoad/index';
import addState from '../states/index';
import addTabs from '../tabs/index';
import zoom from '../zoom/index';
import radioCheckbox from '../product/radioCheckbox';
import { VARIANT_SWITCH } from '../../events';
import { renderMultiProducts } from './MultiProducts';
export async function switchVariants(url, variantIds, shouldUpdateSlider = true) {
    const html = await fetch(url + '&ajax=true', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then((response) => response.ok ? response.text() : Promise.resolve(''));
    if (!html) {
        return;
    }
    document.querySelector('[data-multi-product]').outerHTML = html;
    document.dispatchEvent(new CustomEvent(VARIANT_SWITCH, {
        detail: {
            variantIds,
            shouldUpdateSlider,
        },
    }));
    // Reload JS scripts
    Dropdowns.init();
    addSelectDropdowns();
    addLazyLoad();
    addTabs();
    addState();
    radioCheckbox();
    zoom();
    multiProductsSwitcher();
    renderMultiProducts();
}
export function switchVariantsFromSlider(variantIds) {
    variantIds.find((variantId) => {
        const variantLink = document.querySelector(`a[data-multiproduct-variant-reload-id="${variantId}"]`);
        if (variantLink) {
            switchVariants(variantLink.href, variantIds, false);
            return variantId;
        }
        return false;
    });
}
export default function multiProductsSwitcher() {
    const variantLinks = document.querySelectorAll('a[data-multiproduct-variant-reload-id]');
    variantLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const url = e.target.href;
            const multiProductVariantReloadId = e.target.dataset.multiproductVariantReloadId;
            const slides = Array.from(document.querySelector('.js-slider-product').querySelectorAll('.c-slider__item'));
            const variantIds = JSON.parse(slides.find((slide) => slide.dataset.variantIds.includes(multiProductVariantReloadId))?.dataset.variantIds);
            switchVariants(url, variantIds, true);
        });
    });
}
